module.exports = __webpack_public_path__ + "img/3-4.86557ba4.png";